import { CardProps } from '../../../components/ServiceCard';

export enum ServiceType {
  ALL = 'all',
  TESTS = 'Tests',
  FINANCIAL_SERVICES = 'Financial Services',
  VISA = 'Visa',
  HOUSING = 'Housing',
  ARRIVAL_KITS = 'Arrival Kits',
  ACADEMIC_TOOLS = 'Academic Tools',
}

export const SERVICE_CHIP_QUERY_PARAM = 'service_tab';

export const FILTER_OPTIONS = [
  { label: 'All', value: ServiceType.ALL },
  { label: 'Tests', value: ServiceType.TESTS },
  { label: 'Financial Services', value: ServiceType.FINANCIAL_SERVICES },
  { label: 'Visa', value: ServiceType.VISA },
  { label: 'Housing', value: ServiceType.HOUSING },
  { label: 'Arrival Kits', value: ServiceType.ARRIVAL_KITS },
  { label: 'Academic Tools', value: ServiceType.ACADEMIC_TOOLS },
];

export const VALID_CHIPS = Object.values(ServiceType).filter(
  chip => chip !== ServiceType.ALL,
) as ServiceType[];

export const getInitialSelectedChips = (): string[] => {
  const params = new URLSearchParams(window.location.search);
  const chipParam = params.get(SERVICE_CHIP_QUERY_PARAM);
  if (!chipParam) return [ServiceType.ALL];

  const raw = chipParam.split(',');
  if (raw.includes(ServiceType.ALL)) return [ServiceType.ALL];

  const filtered = raw.filter(t => VALID_CHIPS.includes(t as ServiceType));
  return filtered.length ? filtered : [ServiceType.ALL];
};

export interface ServiceCardData {
  testCardsData: CardProps[];
  visaCardsData: CardProps[];
  filteredGicCards: CardProps[];
  filteredLoanCards: CardProps[];
  filteredBankingCards: CardProps[];
  filteredForexCards: CardProps[];
  filteredHousingCards: CardProps[];
  filteredArrivalKitCards: CardProps[];
  filteredAcademicToolsCards: CardProps[];
}

export const getCardsForService = (
  service: ServiceType,
  cardData: ServiceCardData,
): CardProps[] => {
  switch (service) {
    case ServiceType.TESTS:
      return cardData.testCardsData;
    case ServiceType.VISA:
      return cardData.visaCardsData;
    case ServiceType.ACADEMIC_TOOLS:
      return cardData.filteredAcademicToolsCards;
    case ServiceType.HOUSING:
      return cardData.filteredHousingCards;
    case ServiceType.ARRIVAL_KITS:
      return cardData.filteredArrivalKitCards;
    case ServiceType.FINANCIAL_SERVICES:
      return [
        ...cardData.filteredGicCards,
        ...cardData.filteredLoanCards,
        ...cardData.filteredBankingCards,
        ...cardData.filteredForexCards,
      ];
    default:
      return [];
  }
};
